import { Templates } from '../../compile';
import { StudioNotificationOptions } from '../../interfaces/options';

export const DefaultStudioNotificationOptions: StudioNotificationOptions = {
	title: undefined,
	template: Templates.notification_studioNotification,
	duration: 4
};
